<template>
  <div
    class="flex flex-col justify-center h-auto"
    :class="{'lg:h-full': !isLoggedOut && isCurrentUser}"
  >
    <div
      class="flex flex-col justify-center p-3 py-6 mb-6 text-center border-2 border-gray-500 border-dashed rounded lg:w-full lg:flex-grow-1 lg:h-full lg:mb-10"
      v-if="isCurrentUser"
    >
      <p class="m-0 mb-3 font-bold text-gray-500 ds-text-2xl">Introduce Yourself</p>
      <p
        class="m-0 mb-4 font-normal text-gray-500 ds-text-base"
      >Let coaches get to know you better by telling them about yourself and why you'd be an asset to their team.</p>
      <a href="/athlete_profile" class="inline-block mx-auto">
        <Button text="Add A Bio" emphasis="high" color="blue" @click="trackClick" :short="true" />
      </a>
    </div>
    <div class="font-normal text-gray-900 ds-text-base" v-else>
      <p
        class="italic font-normal text-gray-500 ds-text-base mb-5 lg:self-start"
      >This athlete has not yet added a personal statement.</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Button } from '@sportsrecruits/playbook';
import api from "@/services/api";

export default {
  components: {
    Button
  },
  computed: {
    ...mapGetters({
      isCurrentUser: "athleteProfile/isCurrentUser",
      isLoggedOut: "userData/isLoggedOut",
      isCollegeCoach: "athleteProfile/isApplicableCollegeCoach"
    })
  },
  methods: {
    trackClick() {
      var props = {};
      props.site_access_id = api.clientData().site_access_id;
      props.page = window.location.href;
      props.cta_page = "profile";
      window.SrSegment.track("added_bio", props);
    }
  }
};
</script>

<style scoped>
</style>